var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { setHasFinishedSignup } from '@popup/multichain/actions/has-finished-signup.actions';
import { forgetMk } from '@popup/multichain/actions/mk.actions';
import { navigateTo } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { resetAccount } from '@popup/steem/actions/account.actions';
import { resetActiveAccount } from '@popup/steem/actions/active-account.actions';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ButtonComponent from 'src/common-ui/button/button.component';
import LocalStorageUtils from 'src/utils/localStorage.utils';
const ResetPasswordPage = ({ setTitleContainerProperties, navigateTo, resetAccount, forgetMk, resetActiveAccount, setHasFinishedSignup, }) => {
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_reset',
            isBackButtonEnabled: true,
        });
    }, []);
    const reset = () => __awaiter(void 0, void 0, void 0, function* () {
        resetAccount();
        setHasFinishedSignup(false);
        forgetMk();
        resetActiveAccount();
        yield LocalStorageUtils.clearLocalStorage();
        navigateTo(Screen.SIGN_UP_PAGE, true);
    });
    return (React.createElement("div", { className: "reset-password-page" },
        React.createElement("div", { className: "confirmation-top" },
            React.createElement("p", { className: "introduction", dangerouslySetInnerHTML: {
                    __html: getMessage('popup_html_reset_desc'),
                } })),
        React.createElement("div", { className: "fill-space" }),
        React.createElement(ButtonComponent, { dataTestId: "reset-password-confirm-button", label: "popup_html_confirm", onClick: () => reset() })));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, {
    setTitleContainerProperties,
    navigateTo,
    resetAccount,
    forgetMk,
    resetActiveAccount,
    setHasFinishedSignup,
});
export const ResetPasswordPageComponent = connector(ResetPasswordPage);
